// Configuration file for easily changing parameters across the project
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const API_KEY = 'b82c58e3-41ba-44b4-b20c-4c179db877d3';
export const TIMEOUT_SECS = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
